var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagMexico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_7182",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 2.99997,
    width: 18,
    height: 18,
    rx: 4,
    fill: "#4F9C57"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_7182)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 2.99997,
    width: 18,
    height: 6,
    transform: "rotate(90 21 2.99997)",
    fill: "#BE2D2F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 2.99997,
    width: 18,
    height: 6,
    transform: "rotate(90 9 2.99997)",
    fill: "#2B6649"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 2.99997,
    width: 18,
    height: 8,
    transform: "rotate(90 16 2.99997)",
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    fill: "#957B7B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMexico);
export default __webpack_public_path__ + "static/media/flag-mexico.57807894b9e7cd3d16af2769c4d0c0be.svg";
export { ForwardRef as ReactComponent };